export const CURRENCY_SYMBOLS = {
    DOLLAR: "$",
    INR: "₹",
    EURO: "€",
    POUND: "£",
};
